// extracted by mini-css-extract-plugin
export default {"root":"Overlay_root__iCX7i","container":"Overlay_container__OZeL7"};